// extracted by mini-css-extract-plugin
export default {"container":"LatestNews-module--container--ENA4n","title":"LatestNews-module--title--J-Kbk","itemWrapper":"LatestNews-module--itemWrapper--muyB3"};